<div class="as-row as-justify-end">
    <mat-icon svgIcon="ic-close-green" class="as-pointer" mat-dialog-close></mat-icon>
</div>
<mat-label class="as-roboto-slab as-font-18 as-font-bold"> {{ 'CART.addNote' | translate }} </mat-label>
<form autocomplete="off" [formGroup]="noteForm">
    <textarea class="as-textarea" matInput formControlName="note"
        placeholder="{{ 'CART.notePlaceholder' | translate }}"></textarea>
</form>
<div class="as-actions">
    <button mat-stroked-button color="accent" mat-dialog-close>
        <mat-label class="as-font">
            {{ 'GENERAL.cancel' | translate }}
        </mat-label>
    </button>
    <button mat-flat-button color="accent" (click)="onAddingNote()" [disabled]="!noteForm.valid">
        <mat-label class="as-font-white">
            {{ 'GENERAL.add' | translate }}
        </mat-label>
    </button>
</div>